<template>
  <div id="home_map_wrap">
    <div id="home_map"></div>
    <ul id="getCarStatus">
      <li v-for="(item, index) in carList" :key="index">
        <Tag v-if="item.state == 0" color="warning">空闲</Tag>
        <Tag v-if="item.state == 1" color="success">任务</Tag>
        {{ item.carNo }}
      </li>
    </ul>
  </div>
</template>
<script>
import Theaters from 'tdesign-icons-vue/lib/components/theaters';

var map;
var t;
var cluster = null;
var markers = [];
export default {
  data() {
    return {
      gpsData: [],
      isMarkerClusterer: false,
      carList: [],
      pageTime: null
    };
  },
  methods: {
    getDeviantCarList() {
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-car-server-upf/data/getCarDis",
        data: { returnCoord: 2 },
      }).then((res) => {
        var data = res.data.data;
        this.gpsData = [];
        for (let i = 0; i < data.length; i++) {
          var obj = {
            lng: data[i].x,
            lat: data[i].y,
            name: data[i].carNo,
            alarmList: [],
            icon: data[i].carTypeIcon,
            direction: data[i].direction,
            status: data[i].deviceStatus,
            directionDegree: data[i].directionDegree,
          };
          this.gpsData.push(obj);
        }
        if (this.gpsData.length > 30) {
          this.isMarkerClusterer = true;
        }
        this.showPoints();
      });
    },
    showPoints() {
      var carList = this.gpsData;
      var baseSrc = this.axios.platConfig.fileUri + "mapicon/";

      map.clearMap();
      markers = [];

      for (var i = 0, myMarker; i < carList.length; i++) {
        var direction = 1;
        var angle = carList[i].directionDegree;
        if (carList[i].icon.indexOf("001") != -1) {
          angle = 0;
        }
        if (carList[i].icon.indexOf("002") != -1) {
          direction = carList[i].direction;
        }
        var imgsrc =
          baseSrc +
          carList[i].icon +
          "/" +
          carList[i].status +
          "/" +
          //data_info[i].direction +
          direction +
          ".gif";
        let marks = new AMap.Marker({
          map: map,
          position: [carList[i].lng, carList[i].lat],
          //angle: 0,
          content:
            "<div class='lymapicon'><img style='transform:rotate(" +
            angle +
            "deg);' src='" +
            imgsrc +
            "'/>" +
            "<p>" +
            carList[i].name +
            "</p></div>",
          offset: new AMap.Pixel(-13, -30),
        });
        markers.push(marks);
      }
      map.add(markers)
      map.setFitView(markers);
      // 非气泡模式
      if (!this.isMarkerClusterer) {
        markers = [];
      }

      map.plugin(["AMap.MarkerClusterer"], function () {
        cluster = new AMap.MarkerClusterer(map, markers, {
          maxZoom: 10,
        });
      });
    },

    getPoints() {
      this.axios({
        method: "post",
        url: this.axios.rule + "/marker/list",
        data: {},
      }).then((res) => {
        var data = res.data.data.dataList;
        this.utils.showPoints(map, data, true);
      });
    },
    change() {
      this.isMarkerClusterer = !this.isMarkerClusterer;
      this.showPoints();
    },
    drawMap() {
      map = new AMap.Map("home_map", {
        resizeEnable: true,
      });
      //this.utils.setMap(map);
      //  map.setMapStyle("amap://styles/normal");
      // map.setMapStyle('amap://styles/blue');

      //map.setMapStyle("amap://styles/6bd83b3bf912d2e1c2961f735685146f");
      var that = this;
      map.on("complete", function (ev) {
        that.getPoints();
        that.getDeviantCarList();
        map.setMapStyle("amap://styles/blue");
      });
    },
    getCarStatus() {
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-car-server-dpc/board/countCarState",
        data: {},
      }).then((res) => {
        /* this.carList = res.data.data.sort(function (a, b) {
          return b.state - a.state
        }); */
        var data = res.data.data;
        var total = data.length;
        var pageNumber = 1;
        var pageSize = 12;
        var allPage = Math.ceil(total / pageSize);
        this.carList = this.utils.page(pageNumber, pageSize, data);
        
        console.log('总页码',allPage)
        this.pageTime = setInterval(() => {
          pageNumber++;
          console.log(pageNumber);
          this.carList = this.utils.page(pageNumber, pageSize, data);
          if (pageNumber == allPage) {
            //console.log('daole', pageNumber);
            
            pageNumber = 0;
          }
          
        }, 10000)

      });
    },
  },
  mounted() {

    setTimeout(() => {

      this.drawMap();
      this.getCarStatus();
    }, 800);



  },
  destroyed(){
    clearInterval(this.pageTime);
  }

};
</script>
<style>
#home_map_wrap {
  width: 100%;
  height: 100%;
  position: relative;
}

#home_map {
  width: calc(100% - 10px);
  height: calc(100% - 10px);
  color: #333;
  margin: auto;
}

#home_map .lymapicon {
  text-align: center;
  margin-left: -50px;
  width: 100px;
}

#home_map .lymapicon img {
  width: 30px;
}

#home_map .lymapicon p {
  background: #30327d;
}

#getCarStatus {
  cursor: pointer;
  position: absolute;
  top: 20px;
  right: 10px;
  height: calc(100% - 50px);
  text-align: left;
  overflow: hidden;
  background: rgba(11, 41, 125, 0.5);
  padding: 10px;
}

#getCarStatus li {
  margin-bottom: 4px;
}
</style>


// WEBPACK FOOTER //
// src/components/kanban/abc/ecmap.vue